module.exports = __webpack_public_path__ + "static/media/iar_vehicle_police.dabe6f5a.svg";